import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconArrowSlideIn12 from './IconArrowSlideIn12';
import IconArrowSlideIn16 from './IconArrowSlideIn16';
import IconArrowSlideIn20 from './IconArrowSlideIn20';
import IconArrowSlideIn24 from './IconArrowSlideIn24';
import IconArrowSlideIn32 from './IconArrowSlideIn32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconArrowSlideIn = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconArrowSlideIn12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconArrowSlideIn16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconArrowSlideIn20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconArrowSlideIn24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconArrowSlideIn32 {...props} />}
        </span>
    );
};
IconArrowSlideIn.displayName = 'FondueIconArrowSlideIn';

export default memo(IconArrowSlideIn);
